import { AccoListerApiClient } from '@/scopes/common/infrastructure/acco-lister/accoListerApiClient'
import { DestinationMapAPIClient } from '@/scopes/common/infrastructure/api/destination-map'
import { StoreApi } from 'zustand'
import { DestinationStore } from '../../infrastructure/store/destination-store'
import { DESTINATION_TYPES } from '../destinationTypes'
import { DestinationClient } from '../types/destinationDataClient'

export interface DestinationDependencies {
  store: StoreApi<DestinationStore>
  destinationsSelectorClient: DestinationClient
  destinationMapApiClient: DestinationMapAPIClient
  accoListerApiClient: AccoListerApiClient
  initialWindow?: typeof globalThis
}

export function destinationActions(
  {
    store,
    destinationsSelectorClient,
    destinationMapApiClient,
    accoListerApiClient,
    initialWindow = globalThis,
  }: DestinationDependencies,
) {
  async function pageLoaded() {
    const state = store.getState()
    state.setIn('popularAccosStatus.isLoading', true)
    state.setIn('selectorStatus.isLoading', true)

    const [selectorOptionsResult, accoListerResult] = await Promise.allSettled([
      destinationsSelectorClient.getSelectorOptions(),
      accoListerApiClient.getAccoListerResults(),
    ])

    if (selectorOptionsResult.status === 'fulfilled') {
      state.setIn('selectorOptions', selectorOptionsResult.value)
      state.setIn('selectorStatus.isLoading', false)
    }
    else {
      console.error('Error loading destination selector options:', selectorOptionsResult.reason)
      state.setIn('selectorStatus.hasError', true)
    }

    if (accoListerResult.status === 'fulfilled') {
      state.setIn('popularAccos', accoListerResult.value)
      state.setIn('popularAccosStatus.isLoading', false)
    }
    else {
      console.error('Error loading acco lister results:', accoListerResult.reason)
      state.setIn('popularAccosStatus.hasError', true)
    }
  }

  function destinationSelected({ url }: { url?: string }) {
    if (!url)
      return
    initialWindow.location.href = url
  }

  async function mapOpened({ destinationId, destinationType }: { destinationId: string, destinationType: string }) {
    const state = store.getState()
    if (state.mapAccoMarkers.length > 0)
      return

    state.setIn('mapAccoMarkersStatus.isLoading', true)

    try {
      const { accommodations } = destinationType === DESTINATION_TYPES.REGION
        ? await destinationMapApiClient.getAccosByRegion({ regionId: destinationId })
        : await destinationMapApiClient.getAccosByCountry({ countryId: destinationId })
      store.getState().setIn('mapAccoMarkers', accommodations)
      store.getState().setIn('mapAccoMarkersStatus.isLoading', false)
    }
    catch (error) {
      console.error('Error loading map accommodation markers:', error)
      store.getState().setIn('mapAccoMarkersStatus.hasError', true)
      store.getState().setIn('mapAccoMarkersStatus.isLoading', false)
    }
  }

  return {
    pageLoaded,
    destinationSelected,
    mapOpened,
  }
}
